;(function (window) {	
	
	var PermissionManager = (function(argument) {

		function extend(obj1, obj2){
		    var obj = {};
		    for (var key in obj1) { obj[key] = obj1[key]; }
		    for (var key in obj2) { obj[key] = obj2[key]; }
		    return obj;
		}

		var methods = Object.create(null);
		methods.callbacks = {};

		methods.onPermissionType = function(options){
			this.callbacks = extend(this.callbacks, options);

			return this;
		};

		methods.check = function(router, path_name){
			var
				eventObject     = {},
				permission_field = router.options.controller.permissions[path_name]
			;

			if(!permission_field){
				return true;
			}


			if(typeof permission_field === 'object'){
				eventObject = extend(eventObject, permission_field);
			}
			else{
				eventObject.type = permission_field;
			}
			
			eventObject = extend(eventObject, {
				router: router,
				path_name: path_name
			});

			return this.permissionCallback(eventObject);
		};

		methods.permissionCallback = function(eventObject){
			var
				callback = this.callbacks[eventObject.type],
				proceed = true
			;

			if(typeof callback === 'function'){
				proceed = callback(eventObject);

				if(proceed !== false){
					proceed = true;
				}
			}

			return proceed;
		};

		return methods;
	}());

	window.PermissionManager = PermissionManager;

}(window));